// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import PhraseSpinner from 'app/common/components/PhraseSpinner';

const RandomPhraseSpinner = createReactClass({
  displayName: 'RandomPhraseSpinner',

  propTypes: {
    phrases: PropTypes.array,
  },

  getInitialState() {
    return {
      phrases: _.sample(this.props.phrases),
    };
  },

  render() {
    return <PhraseSpinner {...this.props} phrases={this.state.phrases} />;
  },
});

export default RandomPhraseSpinner;
